export default {"src":"/_next/static/media/Menu.79fde1c3.svg","height":16,"width":20,"blurWidth":0,"blurHeight":0};